// src/pages/SellerForgotPassword.jsx
import React from "react";
import ForgotPassword from "./ForgotPassword";  // generic forgot password flow (seller context)

export default function SellerForgotPassword() {
  return <ForgotPassword />;
}

